const timeToSeconds = (value) => {
    const [hours = 0, minutes = 0, seconds = 0] = value.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
};

export const getShiftDurationHours = (startTime, endTime) => {
    const startSeconds = timeToSeconds(startTime);
    let endSeconds = timeToSeconds(endTime);

    if (endSeconds < startSeconds) {
        endSeconds += 24 * 3600;
    }

    return Math.ceil((endSeconds - startSeconds) / 3600);
};
